import { FileType } from "../constants/misc/FileType";

const getBlobType = (fileType: FileType) => {
    switch (fileType) {
        case FileType.Csv:
            return 'text/csv';
        case FileType.Pdf:
            return 'application/pdf';
        case FileType.Xlsx:
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        case FileType.Zip:
            return 'application/zip';
        default:
            console.error('Undocumented file type');
    }
};

const getFileExtension = (fileType: FileType) => {
    switch (fileType) {
        case FileType.Csv:
            return '.csv';
        case FileType.Pdf:
            return '.pdf';
        case FileType.Xlsx:
            return '.xlsx';
        case FileType.Zip:
            return '.zip';
        default:
            console.error('Undocumented file type');
    }
};

const getFileTypeFromMimeType = (mimeType: string): FileType | null => {
    switch (mimeType) {
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return FileType.Xlsx;
        case 'application/pdf':
            return FileType.Pdf;
        case 'application/zip':
            return FileType.Zip;
        case 'text/csv':
            return FileType.Csv;
        default:
            return null;
    }
};

const useExportToFile = () => {
    const exportFile = async (
        fileName: string,
        dataBlob: Blob,
        requestedFileType: FileType = FileType.Csv
    ) => {
        const detectedFileType = getFileTypeFromMimeType(dataBlob.type);
        const actualFileType = detectedFileType ?? requestedFileType;

        const blob = new Blob([dataBlob], {
            type: getBlobType(actualFileType),
        });
        const anchor = document.createElement('a');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = `${fileName}${getFileExtension(actualFileType)}`;
        anchor.click();
    };

    return { exportFile };
};

export default useExportToFile;
